import { buildTypeList, validateAFM, validateBirthDate, validatePhoneNumber} from "utils";
import { municipalities } from "utils/municipalities";
import { regionalUnities } from "utils/regional_unities";
import { regionalUnitiesWithMunicipalities } from "utils/regional_unities_with_municipalities";
import {treeData } from "utils/treeData";
import { Select } from "antd";
import { FALSE } from "sass";
import { type } from "@testing-library/user-event/dist/type";
import { RadioGroup, Button, Tooltip } from 'components';
import { ReactComponent as Info } from 'assets/icons/info-icon.svg';
const { Option } = Select;


export const formFields111 = [
  {
    label: 'Ενδιαφέρεστε να υποβάλλετε αίτηση για:',
    id: 'equipmentType',
    type: 'select',
    className: 'like-text',
    name: 'equipmentType',
    size: 'large',
    placeholder: 'Επιλέξτε Τύπο',
    span: 24,
    options:[
      { label: 'Αγορά Ηλιακού Θερμοσίφωνα Νέας Τεχνολογίας', id:"equipmentTypeThermosifonas", value: 'equipmentTypeThermosifonas' },
      { label: 'Αγορά Συστήματος Αντλιών Θερμότητας Θέρμανσης', id:"equipmentTypeAntlia", value: 'equipmentTypeAntlia' }
    ],
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      // () => ({
      //   validator(_, value) {
      //     return value && String(value).length !== 5 ? Promise.reject('Το πεδίο πρέπει να έχει ακριβώς 5 ψηφία') : Promise.resolve();
      //   },}),
    ],
    asterisk: true,
  },
  {
    label: 'Επιθυμείτε Επιδότηση των Συμπληρωματικών Υπηρεσιών;',
    id: 'additionalServices',
    type: 'radio',
    className: 'like-text',
    name: 'additionalServices',
    size: 'small',
    span: 24,
    defaultValue: true,
    options:[
      { label: 'Ναι', id:'additionalServicesYes',value: true },
      { label: 'Όχι', id:'additionalServicesNo', value: false }
    ],
    asterisk: true,
  },
  {
    label: 'Επώνυμο',
    id: 'legalSurname',
    type: 'text',
    name: 'legalSurname',
    size: 'large',
    placeholder: 'Εισάγετε Επώνυμο.',
    span: 12,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      { max: 50 , message: 'Το πεδίο μπορεί να έχει το πολύ 50 χαρακτήρες' },
    ],
    asterisk: true,
    disabled: true,
  },
  {
    label: 'Όνομα',
    id: 'legalName',
    type: 'text',
    name: 'legalName',
    size: 'large',
    placeholder: 'Εισάγετε Όνομα.',
    span: 12,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      { max: 50 , message: 'Το πεδίο μπορεί να έχει το πολύ 50 χαρακτήρες' },    ],
    asterisk: true,
    disabled: true,
  },
  {
    label: 'Πατρώνυμο',
    id: 'legalFather',
    type: 'text',
    name: 'legalFather',
    size: 'large',
    placeholder: 'Εισάγετε Πατρώνυμο.',
    span: 12,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      { max: 50 , message: 'Το πεδίο μπορεί να έχει το πολύ 50 χαρακτήρες' },
    ],
    asterisk: true,
    disabled: true,
  },
  {
    label: 'Ημ. Γέννησης',
    type: 'date',
    id: 'birthDate',
    name: 'birthDate',
    allowClear: true,
    size: 'large',
    placeholder: 'Εισάγετε Ημ. Γέννησης',
    className: 'w-100 like-text',
    span: 12,
    asterisk: true,
    disabledDate: d => !d || d.isAfter('2010-12-31'), //|| d.isBefore('2012-01-01') || 
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
    ],
  },
  {
    label: 'Α.Δ.Τ. / Διαβατήριο',
    id: 'legalAdt',
    type: 'text',
    name: 'legalAdt',
    size: 'large',
    placeholder: 'Εισάγετε Α.Δ.Τ. / Διαβατήριο',
    span: 12,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      { max: 10 , message: 'Το πεδίο μπορεί να έχει το πολύ 10 χαρακτήρες' },
    ],
    asterisk: true,
    // style: { marginBottom: '2.5px' },
  },
  {
    label: 'Α.Φ.Μ.',
    id: 'legalVat',
    type: 'text',
    name: 'legalVat',
    size: 'large',
    maxLength: 10,
    placeholder: 'Εισάγετε Α.Φ.Μ.',
    span: 12,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      () => ({
        validator(_, value) {
          return value ? validateAFM(value.toString()) : Promise.resolve();
        },}),
    ],
    asterisk: true,
    disabled: true,
  },
  {
    label: 'Οδός - Αριθμός',
    id: 'abiStreet',
    type: 'text',
    name: 'abiStreet',
    size: 'large',
    placeholder: 'Εισάγετε Οδό - Αριθμό',
    span: 12,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      { max: 50 , message: 'Το πεδίο μπορεί να έχει το πολύ 50 χαρακτήρες' },
    ],
    asterisk: true,
    disabled: true,
  },
  {
    label: 'Τ.Κ.',
    id: 'abiTk',
    type: 'text',
    className: 'like-text',
    name: 'abiTk',
    size: 'large',
    placeholder: 'Εισάγετε Τ.Κ.',
    span: 12,
    maxLength: 5,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      // () => ({
      //   validator(_, value) {
      //     return value && String(value).length !== 5 ? Promise.reject('Το πεδίο πρέπει να έχει ακριβώς 5 ψηφία') : Promise.resolve();
      //   },}),
    ],
    asterisk: true,
  },
  {
    label: <>Περιφερειακή Ενότητα
    <Tooltip
      placement="bottom"
      // className="ml-1"
      title={
        <div className="tooltip-container">
        <span className="info-icon-content">Παρακαλώ συμπληρώστε τον ΤΚ για να επιλέξετε Περιφερειακή Ενότητα.
      </span>
      </div>
      }
    >
      <Info className="infoIconSmallIban" />
    </Tooltip>
    </>
   ,
    id: 'abiPerfecture',
    type: 'select',
    className: 'like-text',
    name: 'abiPerfecture',
    size: 'large',
    // options: regionalUnities,
    showSearch:true,
    placeholder: 'Επιλέξτε Περιφεριακή Ενότητα',
    span: 12,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      // { max: 50 , message: 'Το πεδίο μπορεί να έχει το πολύ 50 χαρακτήρες' },
    ],
    asterisk: true,
  },
  {
    label: <>Δήμος
    <Tooltip
      placement="bottom"
      // className="ml-1"
      title={
        <div className="tooltip-container">
      <span className="info-icon-content">Παρακαλώ συμπληρώστε την Περιφερειακή Ενότητα για να επιλέξετε τον Δήμο.
      </span>
      </div>
      }
    >
      <Info className="infoIconSmallIban" />
    </Tooltip>
    </>
    ,
    id: 'abiDistrict',
    type: 'select',
    className: 'like-text',
    // options: [({getFieldValue}) => {
    //   const prevValue = getFieldValue('abiPerfecture')[0].children;
    //   console.log("prevValue:", prevValue)
    //   return regionalUnitiesWithMunicipalities.filter((word) => word.value === prevValue )}],
    //options: regionalUnitiesWithMunicipalities.filter((word) => word.value == "ΑΙΤΩΛΟΑΚΑΡΝΑΝΙΑΣ")[0].children,
    showSearch:true,
    name: 'abiDistrict',
    size: 'large', //'large' option makes it larger than the other large fields (maybe because it is of type 'select')
    placeholder: 'Επιλέξτε Δήμο',
    span: 12,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      // { max: 50 , message: 'Το πεδίο μπορεί να έχει το πολύ 50 χαρακτήρες' },
    ],
    asterisk: true,
  },
  {
    label: 'Κινητό Τηλέφωνο',
    id: 'legalPhoneMobile',
    type: 'text',
    name: 'legalPhoneMobile',
    simple:true,
    size: 'large',
    placeholder: 'Εισάγετε 69xxxxxxxx',
    span: 24,
    maxLength: 10,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      () => ({
        validator(_, value) {
          return validatePhoneNumber(value.toString(), true);
        },
      }),
    ],
    asterisk: true,
  },
  {
    label: 'E-mail Επικοινωνίας',
    id: 'legalEmail',
    type: 'text',
    name: 'legalEmail',
    size: 'large',
    placeholder: 'Εισάγετε E-mail Επικοινωνίας',
    span: 24,
    maxLength: 50,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      { type: 'email', message: 'Αυτό που εισάγετε δεν είναι έγκυρη διεύθυνση e-mail'}
    ],
    asterisk: true,
  },
];


export const formFields112 = (owner) => [
  {
    label: 'Είστε Ιδιοκτήτης ή Ενοικιαστής;',
    id: 'ownerStatus',
    type: 'radio',
    className: 'like-text',
    name: 'ownerStatus',
    size: 'small',
    span: 24,
    bold: true,
    options:[
      { label: 'Ιδιοκτήτης', id:'ownerStatusOwner',value: 'ownerStatusOwner' },
      { label: 'Ενοικιαστής', id:'ownerStatusRenting', value: 'ownerStatusRenting' },
      { label: 'Χρήστης δωρεάν παραχωρούμενης κατοικίας', id:'ownerStatusFreeConcession', value: 'ownerStatusFreeConcession' },
    ],
    defaultValue: true,
    asterisk: true,
  },
  {
    label: 'Η Κατοικία:',
    id: 'residence',
    type: 'radio',
    className: 'like-text',
    name: 'residence',
    size: 'small',
    span: 24,
    bold: true,
    options:[
      { label: 'Ιδιοκατοικείται', id:'residenceOwned', value: true },
      { label: 'Ενοικιάζεται / Παραχωρείται Δωρεάν από τον Ιδιοκτήτη', id:'residenceRented', value: false }
    ],
    defaultValue: true,
    asterisk: true,
    hidden: owner !== 'ownerStatusOwner',
  },
  {
    label: 'Επώνυμο Ιδιοκτήτη',
    id: 'ownerSurname',
    type: 'text',
    name: 'ownerSurname',
    size: 'large',
    placeholder: 'Εισάγετε Επώνυμο',
    maxLength: 50,
    span: 12,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      { max: 50 , message: 'Το πεδίο μπορεί να έχει το πολύ 50 χαρακτήρες' },
    ],
    asterisk: true,
    hidden: owner === 'ownerStatusOwner',
  },
  {
    label: 'Όνομα Ιδιοκτήτη',
    id: 'ownerFirstname',
    type: 'text',
    name: 'ownerFirstname',
    size: 'large',
    placeholder: 'Εισάγετε Επώνυμο',
    maxLength: 50,
    span: 12,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      { max: 150 , message: 'Το πεδίο μπορεί να έχει το πολύ 150 χαρακτήρες' },
    ],
    asterisk: true,
    hidden: owner === 'ownerStatusOwner',
  },
  {
    label: 'Α.Φ.Μ. Ιδιοκτήτη',
    id: 'ownerVat',
    type: 'text',
    name: 'ownerVat',
    size: 'large',
    maxLength: 10,
    placeholder: 'Εισάγετε Α.Φ.Μ. Ιδιοκτήτη',
    span: 12,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      () => ({
        validator(_, value) {
          return value ? validateAFM(value.toString()) : Promise.resolve();
        },}),
    ],
    asterisk: true,
    hidden: owner === 'ownerStatusOwner',
  },
  {
    label: 'Οδός - Αριθμός',
    id: 'buildStreetBuilding',
    type: 'text',
    name: 'buildStreetBuilding',
    size: 'large',
    placeholder: 'Εισάγετε Οδό - Αριθμό.',
    span: 12,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      { max: 50 , message: 'Το πεδίο μπορεί να έχει το πολύ 50 χαρακτήρες' },
    ],
    asterisk: true,
  },
  {
    label: 'Τ.Κ.',
    id: 'buildTkBuilding',
    type: 'text',
    className: 'like-text',
    simple: true,
    name: 'buildTkBuilding',
    size: 'large',
    placeholder: 'Εισάγετε Τ.Κ.',
    span: 12,
    maxLength: 5,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      () => ({
        validator(_, value) {
          return value && String(value).length !== 5 ? Promise.reject('Το πεδίο πρέπει να έχει ακριβώς 5 ψηφία') : Promise.resolve();
        },}),
    ],
    asterisk: true,
  },
  {
    label: <>Περιφερειακή Ενότητα
      <Tooltip
        placement="bottom"
        // className="ml-1"
        title={
          <div className="tooltip-container">
          <span className="info-icon-content">Παρακαλώ συμπληρώστε τον ΤΚ για να επιλέξετε Περιφερειακή Ενότητα.
        </span>
        </div>
        }
      >
        <Info className="infoIconSmallIban" />
      </Tooltip>
      </>
    ,
    type: 'select',
    className: 'like-text',
    id: 'buildPerfectureBuilding',
    title: 'Περιφερειακή Ενότητα',
    showSearch:true,
    name: 'buildPerfectureBuilding',
    size: 'large',
    placeholder: 'Εισάγετε Περιοχή',
    span: 12,
    rules: [
      { required: false, message: 'Το πεδίο είναι υποχρεωτικό' },
      { max: 50 , message: 'Το πεδίο μπορεί να έχει το πολύ 50 χαρακτήρες' },
    ],
    asterisk: true,
    // style: { marginBottom: '-4px' },
  },
  {
    label: <>Δήμος
      <Tooltip
        placement="bottom"
        // className="ml-1"
        title={
          <div className="tooltip-container">
        <span className="info-icon-content">Παρακαλώ συμπληρώστε την Περιφερειακή Ενότητα για να επιλέξετε τον Δήμο.
        </span>
        </div>
        }
      >
        <Info className="infoIconSmallIban" />
      </Tooltip>
      </>
    ,
    id: 'abiDistrictBuilding',
    type: 'select',
    className: 'like-text',
    showSearch:true,
    name: 'abiDistrictBuilding',
    size: 'large',
    placeholder: 'Επιλέξτε Δήμο',
    span: 12,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      // { max: 50 , message: 'Το πεδίο μπορεί να έχει το πολύ 50 χαρακτήρες' },
    ],
    asterisk: true,
  },
  {
    label: 'Αρ. Παροχής Ρεύματος',
    id: 'powerNumberBuilding',
    type: 'text',
    name: 'powerNumberBuilding',
    size: 'large',
    placeholder: 'Εισάγετε Αρ. Παροχής Ρεύματος',
    sublabel: '11-ψήφιο αριθμό παροχής ηλεκτρικού ρεύματος συμπεριλαμβανομένης της παύλας (-)',
    maxLength: 50,
    span: 24,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      { max: 30 , message: 'Το πεδίο μπορεί να έχει το πολύ 50 χαρακτήρες' },
    ],
    asterisk: true,
  },
  {
    label: <>
      Είναι Ενεργή η Παροχή Ρεύματος;
      <Tooltip
        placement="bottom"
        // className="ml-1"
        title={
          <div className="tooltip-container">
          <span className="info-icon-content">Προσοχή! <br/><br/>Η παροχή ρεύματος του ακινήτου πρέπει να είναι Ενεργή,<br/> διαφορετικά εναντιώνεται στους όρους του προγράμματος και <br/>δεν μπορείτε να ολοκληρώσετε την αίτηση.
        </span>
        </div>
        }
      >
        <Info className="infoIconSmallIban" />
      </Tooltip>
      </>
    ,
    sublabel: 'Δεν γίνονται δεκτές οι Ανενεργές Παροχές',
    id: 'powerSupply',
    type: 'radio',
    className: 'like-text',
    name: 'powerSupply',
    size: 'small',
    span: 24,
    bold: true,
    options:[
      { label: 'Ναι', id:'powerOn',value: true },
      { label: 'Όχι', id:'powerOff', value: false }
    ],
    defaultValue: true,
    asterisk: true,
  },
  {
    label:<>Είναι η Παροχή Ρεύματος Οικιακή;
          <Tooltip
          placement="bottom"
          // className="ml-1"
          title={
            <div className="tooltip-container">
            <span className="info-icon-content">Προσοχή! <br/><br/>Η παροχή ρεύματος του ακινήτου θα πρέπει να είναι Οικιακή,<br/> διαφορετικά εναντιώνεται στους όρους του προγράμματος και <br/>δεν μπορείτε να ολοκληρώσετε την αίτηση.
          </span>
          </div>
          }
        >
          <Info className="infoIconSmallIban" />
        </Tooltip>
      </>,
    sublabel: 'Δεν γίνονται δεκτές Παροχές που δεν είναι Οικιακές',
    id: 'powerSupplyPrivate',
    type: 'radio',
    className: 'like-text',
    name: 'powerSupplyPrivate',
    size: 'small',
    bold: true,
    options:[
      { label: 'Ναι', id:'powerSupplyPrivateYes',value: true },
      { label: 'Όχι', id:'powerSupplyPrivateNo', value: false }
    ],
    defaultValue: true,
    asterisk: true,
  },
  {
    label:<>Είναι η Παροχή Ρεύματος Κοινόχρηστη;
      <Tooltip
        placement="bottom"
        // className="ml-1"
        title={
          <div className="tooltip-container">
          <span className="info-icon-content">Προσοχή! <br/><br/>Η παροχή ρεύματος του ακινήτου δεν πρέπει να είναι Κοινόχρηστη,<br/> διαφορετικά εναντιώνεται στους όρους του προγράμματος και δεν<br/> μπορείτε να ολοκληρώσετε την αίτηση.
        </span>
        </div>
        }
      >
      <Info className="infoIconSmallIban" />
    </Tooltip>
    </>,
    sublabel: ' Δεν γίνονται δεκτές οι κοινόχρηστες παροχές',
    id: 'powerSupplyPublic',
    type: 'radio',
    className: 'like-text',
    name: 'powerSupplyPublic',
    size: 'small',
    span: 24,
    bold: true,
    options:[
      { label: 'Ναι', id:'powerSupplyPublicYes',value: true },
      { label: 'Όχι', id:'powerSupplyPublicNo', value: false }
    ],
    defaultValue: true,
    asterisk: true,
  },
].filter(item => !item?.hidden);

export const formFields21 = [
  {
    label: 'Υπάρχει Μέλος ΑΜΕΑ στην Οικογένεια;',
    id: 'ameaMember',
    type: 'radio',
    className: 'like-text',
    name: 'ameaMember',
    size: 'small',
    span: 24,
    options:[
      { label: 'Ναι', id:'ownerStatusYes',value: true },
      { label: 'Όχι', id:'ownerStatusNo', value: false }
    ],
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
    ],
    asterisk: true,
  },
  {
    label: 'Αρ. Εξαρτώμενων Τέκνων',
    id: 'legalChildren',
    type: 'text',
    name: 'legalChildren',
    size: 'large',
    placeholder: 'Εισάγετε Αριθμό Τέκνων',
    simple: true,
    span: 12,
    maxLength: 2,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      { max: 2 , message: 'Το πεδίο μπορεί να έχει το πολύ 2 χαρακτήρες' },
    ],
    asterisk: true,
  },  
];

export const formFields22 = [   //add validation if less than 2000 turn off submit
  {
    label: 'Ατομικό Εισόδημα 2023',
    id: 'individualIncome',
    name: 'individualIncome',
    type: 'number',
    maxLength: 13,
    size: 'large',
    placeholder: 'Εισάγετε το Ατομικό σας Εισόδημα του 2023',
    span: 12,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },    ],
    asterisk: true,
  },
  {
    label: 'Οικογενειακό Εισόδημα 2023',
    id: 'legalIncome',
    type: 'number',
    maxLength: 13,
    name: 'legalIncome',
    size: 'large',
    placeholder: 'Εισάγετε το Οικογενειακό σας Εισόδημα του 2023',
    span: 12,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
    ],
    asterisk: true,
  },
];




